export default __webpack_public_path__ + "static/media/kiragu.e1f6d2f3.jpg";